module.exports = __webpack_public_path__ + "media/15-6.4cae194c.mp4";